<section class="Receipt gray_baack redeem-vouchers">
	<div class="container">
	   <h2 class="title text-center"> redeem vouchers </h2>
		<div class="row mt-4 pt-4">

		 		<div class="col-md-4 " *ngFor="let vou of promotional | slice:0:20">
				    <div class="gifts">
						<img loading="lazy" src="{{imageUrl}}{{vou.image}}" (error)="onImg($event)">
				  		<p class="" >{{vou.code}}</p>
				  		<h3 >${{vou.amount}}</h3>
				  		<!-- <img loading="lazy" src="../../../../assets/images/copy.png" > -->
				    </div>
				</div>
	</div>
	</div>
</section>
